module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/technicalservice/technicalservice.component.html
// module id = 1285
// module chunks = 0